<template>
  <main id="create-quote-page" class="page-container">
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- [sc-49299] nuovo articolo dal preventivo -->
    <CreaArticoloModal
      v-model:show="showCreaArticolo"
      :nome-iniziale="nomeNuovoArticolo"
      @creato="onArticoloCreato"
    />

    <!-- Modale DUPLICATO preventivo -->
    <VueFinalModal
      v-model="showDuplicateModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content dup-modal__content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="closeDuplicateModal">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo già presente</h3>

        <p class="dup-modal__intro">
          Esiste già un preventivo per questo cliente allo stesso indirizzo in
          corso...
          <span
            v-if="lastDuplicateQuoteInfo?.address"
            class="dup-modal__address"
          >
            ({{ lastDuplicateQuoteInfo.address }}) </span
          >.
        </p>

        <!-- Stato: loading -->
        <div v-if="dupLoading" class="dup-modal__skeleton">
          Caricamento in corso…
        </div>

        <!-- Stato: errore -->
        <div v-else-if="dupError" class="dup-modal__error">
          {{ dupError }}
        </div>

        <!-- Stato: dati -->
        <div v-else-if="dupQuote" class="dup-quote">
          <div class="dup-quote__grid">
            <div>
              <div class="dup-quote__label">ID</div>
              <div class="dup-quote__value">#{{ dupQuote.id }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Data</div>
              <div class="dup-quote__value">
                {{ formatToLocalDate(dupQuote.date) }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Cliente</div>
              <div class="dup-quote__value">
                {{ dupQuote.clientName || "—" }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Pagamento</div>
              <div class="dup-quote__value">{{ dupQuote.payment_method }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Indirizzo</div>
              <div class="dup-quote__value">
                <a
                  v-if="dupQuote.location?.link"
                  :href="dupQuote.location.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="custom-link"
                >
                  {{ dupQuote.location?.address || "Vedi mappa" }}
                </a>
                <span v-else>{{ dupQuote.location?.address || "—" }}</span>
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Totale</div>
              <div class="dup-quote__value">
                {{ money(dupQuote.totalPrice) }}
              </div>
            </div>
          </div>

          <div class="dup-quote__items">
            <div class="dup-quote__items-head">
              <strong>Riepilogo articoli</strong>
              <span class="muted">({{ dupQuote.items?.length || 0 }})</span>
            </div>
            <ul class="dup-quote__items-list">
              <li
                v-for="(it, idx) in dupQuote.items || []"
                :key="idx"
                class="dup-item"
              >
                <div class="dup-item__name">
                  {{ it.itemName || it.brand || "Articolo" }}
                </div>
                <div class="dup-item__meta">
                  <span v-if="it.category" class="chip">{{ it.category }}</span>
                  <span v-if="it.boxQuantity"
                    >scatole: {{ it.boxQuantity }}</span
                  >
                  <span v-if="it.pieces">pezzi: {{ it.pieces }}</span>
                  <span v-if="it.iva !== undefined">IVA: {{ it.iva }}%</span>
                  <span v-if="it.price !== undefined"
                    >€ {{ number(it.price) }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="dup-modal__footer">
          <!-- Apri file (si vede solo se ho caricato docs) -->
          <button
            v-if="dupQuote && !dupLoading && dupDocuments.length"
            class="btn-primary"
            @click="showDupDocs = true"
          >
            Apri file
          </button>
          <!-- <router-link
            v-if="lastDuplicateQuoteInfo?.quoteId"
            class="btn primary"
            :to="`/quote/${lastDuplicateQuoteInfo.quoteId}`"
            @click="onViewedExisting"
          >
            Apri preventivo esistente
          </router-link> -->

          <button class="btn-primary" @click="onChangeAddress">
            Usa indirizzo diverso
          </button>

          <button
            class="btn-ghost"
            :disabled="!lastDuplicateQuoteInfo?.quoteId"
            @click="onDuplicateWithEdit"
          >
            Duplica modificando indirizzo
          </button>
        </div>

        <!-- DEV: riquadro debug, rimuovi quando hai finito -->
        <!-- <div
          v-if="showDuplicateModal"
          style="margin-top: 12px; font-size: 12px; color: #555"
        >
          <details>
            <summary>Debug dup</summary>
            <pre style="white-space: pre-wrap; word-break: break-word">
lastDuplicateQuoteInfo: {{ lastDuplicateQuoteInfo }}
dupLoading: {{ dupLoading }}
dupError: {{ dupError }}
dupQuote: {{ dupQuote }}
    </pre
            >
          </details>
        </div> -->
      </template>
    </VueFinalModal>

    <VueFinalModal
      v-model="showDupDocs"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="documents-modal-content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="showDupDocs = false">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo #{{ dupQuote?.id }}</h3>

        <div class="documents-grid">
          <div v-for="doc in dupDocuments" :key="doc.id" class="document-card">
            <a href="#" class="card-link" @click.prevent="openDoc(doc)">
              <div class="card-icon-pdf">
                <i class="fa-solid fa-file-pdf"></i>
              </div>
              <div class="card-body">
                <div class="card-title">{{ formatDocName(doc.name) }}</div>
                <div class="card-subtitle">
                  Data di creazione: {{ formatToLocalDate(doc.createdAt) }}
                </div>
              </div>
            </a>
          </div>

          <div v-if="dupDocuments.length === 0" class="no-result">
            Nessun documento trovato
          </div>
        </div>
      </template>
    </VueFinalModal>

    <div class="create-quote-wrapper">
      <div class="create-quote-main-col" ref="mainCol">
        <!-- Form principale -->
        <form
          class="create-quote-form"
          @submit.prevent="onCreateQuoteAndGeneratePdf"
        >
          <!-- RIGA 1: Seleziona Cliente, data di inizio noleggio, data di fine noleggio e Operatore, Aggiungi Zona e categoria di articolo -->
          <div class="create-quote-row row-1 form-stack">
            <!-- Seleziona Cliente -->
            <div class="field" id="client-select">
              <label>Cliente *</label>
              <SearchableCombo
                v-model="formData.clientId"
                :items="comboClients"
                :labelKey="
                  (c) =>
                    c.email
                      ? `${c.clientName} - (${c.email})`
                      : c.pec
                      ? `${c.clientName} - (${c.pec})`
                      : c.clientName
                "
                :valueKey="(c) => c.id"
                placeholder="Cerca cliente..."
                :loading="clientsLoading"
                emptyText="Nessun risultato"
                @search="onSearchClient"
                @open="onSearchClient"
                @select="selectClient"
              />
            </div>

            <!-- Data Preventivo -->
            <div class="field">
              <label for="date">Data</label>
              <FlatPickr
                id="date"
                v-model="formData.date"
                :config="dateConfig"
                placeholder="gg/mm/aaaa"
              />
            </div>
          </div>

          <div class="create-quote-row row-2 form-stack">
            <!-- Indirizzo di consegna -->
            <div class="field">
              <small v-if="addressDirty && !isAddressValid" class="help-error">
                Scrivi l'indirizzo di consegna.
              </small>
              <label for="indirizzo-consegna">Indirizzo di consegna *</label>
              <!-- [sc-48860] propone residenza e cantiere del cliente -->
              <IndirizzoConsegna
                v-model="addressInput"
                :cliente="clienteSelezionato"
                @input="onAddressTyping"
                @blur="addressDirty = true"
              />
            </div>

            <!-- modalità di pagamento -->
            <div class="field">
              <label for="payment-method">Modalità di pagamento *</label>
              <StatusSelect
                v-model="formData.payment_method"
                :options="paymentOptions"
                placeholder="Seleziona metodo..."
                placeholderIcon="fa-wallet"
              />
            </div>
          </div>
          <hr />

          <!-- RIGA 3: scegli articolo, scegli quantità e prezzo, + bottone "aggiungi articolo" -->
          <div class="create-quote-row row-3 form-stack">
            <!-- scegli Articolo -->
            <div class="field" id="item-select">
              <label for="item-search">Articolo *</label>
              <SearchableCombo
                v-model="newItem.itemId"
                v-model:text="searchQueryItem"
                :items="filteredItems"
                :labelKey="itemSearchLabel"
                :valueKey="(it) => it.id"
                placeholder="Cerca articolo..."
                :disabled="false"
                :loading="itemsLoading"
                emptyText="Nessun risultato"
                :footerText="conteggioArticoli"
                @search="onSearchItem"
                @open="onSearchItem"
                @select="selectItem"
                @cleared="clearItemSelection"
                @load-more="caricaAltriArticoli"
              >
                <template #option="{ option }">
                  <span
                    class="quote-item-option__label"
                    :class="{ 'is-out': isOrderableOutOfStock(option) }"
                  >
                    <span v-if="isOrderableOutOfStock(option)">! </span
                    >{{ itemSearchLabel(option) }}
                  </span>
                  <!-- [sc-48920] codice · brand · serie: perché è uscito -->
                  <span
                    v-if="dettaglioVoceArticolo(option)"
                    class="quote-item-option__sub"
                    >{{ dettaglioVoceArticolo(option) }}</span
                  >
                </template>
                <!-- [sc-49389] ricerca senza risultati: si crea da qui -->
                <template #empty="{ close }">
                  <span class="crea-articolo-riga">
                    Nessun risultato
                    <button
                      type="button"
                      class="crea-articolo-link"
                      @click="creaArticoloDaRicerca(close)"
                      @touchend.prevent="creaArticoloDaRicerca(close)"
                    >
                      <i class="fa-solid fa-circle-plus" aria-hidden="true"></i>
                      <span>Crea articolo</span>
                    </button>
                  </span>
                </template>
              </SearchableCombo>
              <!-- [sc-49299] articolo non a listino: si crea da qui -->
              <p class="crea-articolo-riga">
                Articolo non trovato?
                <button
                  type="button"
                  class="crea-articolo-link"
                  @click="showCreaArticolo = true"
                >
                  <i class="fa-solid fa-circle-plus" aria-hidden="true"></i>
                  <span>Crea articolo</span>
                </button>
              </p>
            </div>

            <!-- Scegli Quantità -->
            <div class="field">
              <label :for="'quantity'">{{ quantityLabel }} *</label>
              <input
                id="quantity"
                type="number"
                step="any"
                v-model="quantityInput"
                placeholder="Inserisci quantità"
              />
            </div>
            <!-- quantità al Mq / ML => readonly -->
            <div class="field" v-if="showMqField">
              <label for="mq-per-box">{{ mqFieldLabel }}</label>
              <input
                :value="mqPerQuantity"
                type="text"
                step="any"
                placeholder="Seleziona la quantità di scatole per visualizzare i mq"
                readonly
                class="readonly-field"
              />
            </div>
          </div>
          <div class="create-quote-row row-4 form-stack">
            <!-- Prezzi: listino fisso, scontato correggibile (IVA esclusa) -->
            <div class="field">
              <label for="list-price">Prezzo listino — IVA esclusa</label>
              <input
                id="list-price"
                type="text"
                :value="
                  newItem.listPrice != null ? `€ ${eur(newItem.listPrice)}` : ''
                "
                placeholder="Seleziona l'articolo per visualizzare il prezzo corrispondente"
                readonly
                class="readonly-field"
              />
            </div>
            <div class="field">
              <label for="discounted-price">Prezzo scontato</label>
              <input
                id="discounted-price"
                type="number"
                v-model="newItem.discountedPrice"
                placeholder="Prezzo netto scontato (opzionale)"
                step="0.01"
                min="0"
                :disabled="!newItem.itemId"
                :class="{ invalid: erroreScontatoRiga }"
              />
              <small v-if="erroreScontatoRiga" class="help-error">{{
                erroreScontatoRiga
              }}</small>
            </div>
            <div class="field">
              <label for="vat-rate">IVA</label>
              <StatusSelect
                v-model="newItem.iva"
                :options="ivaOptions"
                placeholderIcon="fa-percent"
              />
            </div>

            <!-- Anteprima della riga prima di aggiungerla -->
            <div
              class="item-preview"
              :class="{ 'is-invalid': !!erroreScontatoRiga }"
              aria-live="polite"
            >
              <div>
                Imponibile:
                <b>{{ importoAnteprima(anteprimaNuovaRiga.imponibile) }}</b>
              </div>
              <div>
                Aliquota: <b>{{ anteprimaNuovaRiga.aliquota }}%</b>
              </div>
              <div>
                Imposta:
                <b>{{ importoAnteprima(anteprimaNuovaRiga.imposta) }}</b>
              </div>
              <div class="item-preview__total">
                Totale: {{ importoAnteprima(anteprimaNuovaRiga.totale) }}
              </div>
            </div>
          </div>

          <!-- RIGA 3: bottone "+ aggiungi articolo" + "Mostra articoli" -->
          <div class="create-quote-row row-5">
            <!-- Bottone per aggiungere un ulteriore alla lista -->
            <div class="field">
              <button type="button" class="add-item-btn" @click="addItem">
                <i class="fa-solid fa-plus" aria-hidden="true"></i>
                <span>Aggiungi articolo</span>
              </button>
            </div>

            <!-- Apri pannello articoli (visibile solo quando chiuso) -->
            <button
              v-if="!panelVisible"
              type="button"
              @click="toggleItemsList"
              class="panel-open-btn"
              title="Mostra articoli aggiunti"
            >
              <i class="fa-solid fa-list"></i>
              Mostra articoli
            </button>
          </div>
        </form>

        <hr />

        <!-- [sc-49299] spese aggiuntive, senza IVA -->
        <div class="create-quote-row spese-row">
          <SpeseAggiuntive v-model="spese" />
        </div>

        <hr />

        <!-- RIGA 6: note + cambio lingua -->
        <div class="create-quote-row row-5 notes-row">
          <!-- Richieste tecniche -->
          <div class="field">
            <label for="technical-requests">Note</label>
            <textarea
              id="technical-requests"
              v-model.trim="formData.technical_queries"
              placeholder="Inserisci note"
              maxlength="2000"
              rows="3"
            ></textarea>
          </div>
          <!-- Esempio di dropdown per il cambio lingua -->
          <!-- <div class="field">
            <label for="lang-select">Lingua PDF:</label>
            <select v-model="$i18n.locale" id="lang-select" class="pdf-lang-select">
              <option value="it">Italiano</option>
              <option value="en">English</option>
            </select>
          </div> -->
        </div>
      </div>
      <!-- /.create-quote-main-col -->

      <!-- Backdrop mobile (clic per chiudere) -->
      <div
        v-if="panelVisible"
        class="panel-backdrop"
        @click="toggleItemsList"
      ></div>

      <!-- Colonna pannello + bottone salva -->
      <div class="panel-col" v-show="panelVisible">
        <aside class="items-panel" ref="itemsPanel">
          <div class="items-panel__title-bar">
            <h3 class="items-panel__title">Articoli aggiunti</h3>
            <button
              type="button"
              @click="toggleItemsList"
              class="items-panel__close-btn"
              title="Chiudi pannello"
              aria-label="Chiudi pannello articoli"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="items-panel__table-wrap">
            <table class="items-panel__table">
              <thead>
                <tr>
                  <th>Codice</th>
                  <th>Articolo</th>
                  <th>Categoria</th>
                  <th>Qtà</th>
                  <th>Misura</th>
                  <th>Prezzo ivato</th>
                  <th>IVA</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in formData.items"
                  :key="`stk-${item.itemId}-${item.iva}`"
                >
                  <td class="item-code-cell">
                    {{
                      getItemFromStore(item.itemId, categoryHintForRow(item))
                        .itemCode ?? "—"
                    }}
                  </td>
                  <td class="item-cell">
                    <div class="item-title">{{ itemDisplay(item).title }}</div>
                    <div v-if="itemDisplay(item).meta" class="item-meta">
                      {{ itemDisplay(item).meta }}
                    </div>
                  </td>
                  <td>
                    {{
                      getItemFromStore(item.itemId, categoryHintForRow(item))
                        .category
                    }}
                  </td>
                  <td>
                    <input
                      type="number"
                      class="panel-qty-input"
                      :value="qtyCell(item)"
                      min="0"
                      step="1"
                      @change="updateRowQty(item, +$event.target.value)"
                    />
                    <template
                      v-if="
                        isOrderableOutOfStock(
                          getItemFromStore(
                            item.itemId,
                            categoryHintForRow(item)
                          )
                        )
                      "
                    >
                      <span
                        v-if="isOrderQueuedRow(item)"
                        class="item-order-queued-badge"
                        >Ordine in coda</span
                      >
                      <span v-else class="item-order-queued-badge"
                        >Esaurito</span
                      >
                      <button
                        type="button"
                        class="quote-order-btn"
                        :class="{ 'is-cancel': isOrderQueuedRow(item) }"
                        @click.stop="
                          isOrderQueuedRow(item)
                            ? unqueueOrderFromQuoteItem(
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                )
                              )
                            : queueOrderFromQuoteItem(
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                )
                              )
                        "
                      >
                        {{ isOrderQueuedRow(item) ? "Annulla" : "Ordina" }}
                      </button>
                    </template>
                    <template v-else-if="isQtyExceedingStock(item)">
                      <span
                        v-if="isOrderQueuedRow(item)"
                        class="item-order-queued-badge"
                        >Ordine in coda</span
                      >
                      <span
                        v-else
                        class="item-order-queued-badge item-not-available-badge"
                        >Non disponibile</span
                      >
                      <button
                        type="button"
                        class="quote-order-btn"
                        :class="{ 'is-cancel': isOrderQueuedRow(item) }"
                        @click.stop="
                          isOrderQueuedRow(item)
                            ? unqueueOrderFromQuoteItem(
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                )
                              )
                            : queueOrderFromQuoteItem(
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                )
                              )
                        "
                      >
                        {{ isOrderQueuedRow(item) ? "Annulla" : "Ordina" }}
                      </button>
                    </template>
                  </td>
                  <td>{{ mqCell(item) }}</td>
                  <td>{{ formatPrice(item.price) }} {{ unitForRow(item) }}</td>
                  <td>{{ formatIva(item.iva) }}</td>
                  <td>
                    <button
                      class="icons-button"
                      @click="removeItem(idx)"
                      title="Rimuovi articolo dalla lista"
                      aria-label="Rimuovi articolo dalla lista"
                    >
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="formData.items.length === 0">
                  <td colspan="8" class="no-result">
                    Nessun articolo presente
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="items-panel__footer">
            {{ formData.items.length }}
            {{ formData.items.length === 1 ? "articolo" : "articoli" }}
            <button
              class="icons-button"
              type="button"
              :title="
                pendingDdt
                  ? `DDT in coda (${pendingDdt.causale}) — clicca per modificare`
                  : 'Genera DDT dalla lista materiale'
              "
              :disabled="formData.items.length === 0"
              @click="showDdtModal = true"
              style="margin-left: 8px"
              :class="{ 'ddt-queued-active': pendingDdt }"
            >
              <i class="fa-solid fa-truck"></i>
            </button>
            <span
              v-if="pendingDdt"
              class="ddt-queued-badge"
              title="DDT verrà generato al salvataggio"
            >
              {{ pendingDdt.causale }}
            </span>
          </div>
        </aside>

        <div class="save-button-container">
          <button
            id="save-quote"
            class="primary-btn"
            @click="onCreateQuoteAndGeneratePdf"
            :disabled="!canSaveCreate"
            :title="
              erroreSpese
                ? `Spese aggiuntive — ${erroreSpese}`
                : !canSaveCreate
                ? 'Compila i campi obbligatori (*) per vedere l’anteprima'
                : 'Vedi il PDF, scegli cosa stampare e salva il preventivo'
            "
          >
            Anteprima preventivo
          </button>
        </div>
      </div>
      <!-- /.panel-col -->
    </div>
    <!-- /.create-quote-wrapper -->
    <DdtModal
      :show="showDdtModal"
      :items="ddtItems"
      :quote-id="null"
      :client-id="formData.clientId || null"
      :client-name="null"
      :deferred="true"
      @update:show="showDdtModal = $event"
      @queued="pendingDdt = $event"
    />

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>

    <!-- [sc-49299] «Anteprima preventivo»: si salva solo da qui -->
    <StampaPreventivoModal
      :show="stampa.show"
      :dati="stampa.dati"
      :salvando="stampa.salvando"
      etichetta-scarica="Salva e scarica PDF"
      @scarica="onScaricaStampa"
      @chiudi="onChiudiStampa"
    />
  </main>
</template>

<script>
// import crypto from "crypto";
import axiosInstance from "@/axiosInstance";
import { eur } from "@/utilities/pdfRiepilogo";
import debounce from "lodash/debounce";
import { generateDdtPdf } from "@/utilities/generateDdtPdf";
// import { nextTick } from "process";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate } from "../utilities/formatting";
import SearchableCombo from "./SearchableCombo.vue";
import CreaArticoloModal from "@/components/CreaArticoloModal.vue";
import SpeseAggiuntive from "@/components/SpeseAggiuntive.vue";
import {
  primoErroreSpese,
  speseDaMandare,
  speseDaPreventivo,
} from "@/utilities/spese";
import ricercaArticoliPreventivo from "@/mixins/ricercaArticoliPreventivo";
import apriDocumento from "@/mixins/apriDocumento";
import stampaPreventivo from "@/mixins/stampaPreventivo";
import StampaPreventivoModal from "@/components/StampaPreventivoModal.vue";
import { clientePerPdf, datiPdf } from "@/utilities/pdfPreventivo";
import {
  prezzoIvatoRiga,
  totaleArticoli,
} from "@/utilities/anteprimaPreventivo";
import DdtModal from "@/components/DdtModal.vue";
import StatusSelect from "@/components/StatusSelect.vue";
import { clientiPerRicerca } from "@/utilities/cliente";
import IndirizzoConsegna from "@/components/IndirizzoConsegna.vue";
import { dettaglioVoceArticolo } from "@/utilities/filtriListino";
import {
  erroreScontato,
  numeroPrezzo,
  prezzoBase,
  prezzoIvato,
  prezziRigaDuplicata,
  anteprimaRiga,
} from "@/utilities/prezzoArticolo";
import FlatPickr from "vue-flatpickr-component";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { linkMaps, indirizzoValido } from "@/utilities/indirizzo";
// import DuplicateQuoteModal from "./DuplicateQuoteModal.vue";

const KEY = {
  STOCK: (id) => `STOCK:${Number(id)}`,
};

const COLUMN_GROUPS = {
  area: [
    "piastrelle",
    "rivestimenti parete",
    "parquet",
    "laminati",
    "decking esterno",
  ],
  piece: ["sanitari", "rubinetteria", "box doccia", "accessori bagno"],
  linear: ["profili", "sistemi di scarico"],
  furniture: ["mobili", "porte e infissi"],
};

function getCategoryGroup(category) {
  for (const [group, cats] of Object.entries(COLUMN_GROUPS)) {
    if (cats.includes(category)) return group;
  }
  return "generic";
}

// 👇 helper per location: stringa JSON o oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw; // è già un oggetto
};

export default {
  // [sc-48920] menu articolo a pagine: filteredItems, itemsLoading, fetchItems
  mixins: [ricercaArticoliPreventivo, apriDocumento, stampaPreventivo],
  components: {
    SearchableCombo,
    StampaPreventivoModal,
    CreaArticoloModal,
    SpeseAggiuntive,
    DdtModal,
    StatusSelect,
    FlatPickr,
    IndirizzoConsegna,
  },
  beforeRouteLeave(to) {
    if (this.navigationConfirmed || to.name === "login") {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  created() {
    this.$store
      .dispatch("fetchClients", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare i clienti: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    // this.$store.dispatch("fetchOperators");
    this.$store
      .dispatch("fetchItems", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare gli articoli: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    this.debouncedFetchItems = debounce(this.fetchItems, 200);
  },
  computed: {
    // Anteprima della riga in inserimento: la quantità fatturata è in mq o ml
    // per le categorie a scatola, come nel totale del preventivo
    anteprimaNuovaRiga() {
      // Scontato non valido: niente cifre, solo l'errore sotto il campo
      if (this.erroreScontatoRiga) {
        return {
          imponibile: null,
          aliquota: this.newItem.iva,
          imposta: null,
          totale: null,
        };
      }
      const s = this.selectedItem || {};
      const g = getCategoryGroup(s.category);
      const scatole = Number(this.newItem.boxQuantity) || 0;
      const quantita =
        g === "area"
          ? scatole * (Number(s.sqmPerBox) || 1)
          : g === "linear"
          ? scatole * (Number(s.mlPerBox) || 1)
          : Number(this.newItem.pieces) || 0;
      return anteprimaRiga({
        listPrice: this.newItem.itemId ? this.newItem.listPrice : null,
        discountedPrice: this.newItem.itemId
          ? this.newItem.discountedPrice
          : null,
        iva: this.newItem.iva,
        quantita,
      });
    },
    // Lo scontato della riga in inserimento deve restare sotto il listino
    erroreScontatoRiga() {
      if (!this.newItem.itemId) return null;
      return erroreScontato(
        this.newItem.listPrice,
        this.newItem.discountedPrice
      );
    },
    clients() {
      return this.$store.getters["clients/list"] ?? [];
    },
    // [sc-48860] cliente del preventivo, per proporre i suoi indirizzi di consegna
    clienteSelezionato() {
      const id = Number(this.formData.clientId);
      return (this.clients || []).find((c) => c.id === id) || null;
    },
    selectedItem() {
      if (this.newItem.itemId) {
        return this.getItemFromStore(this.newItem.itemId, "STOCK");
      }
      return {};
    },
    selectedItemGroup() {
      return getCategoryGroup(this.selectedItem?.category);
    },
    quantityLabel() {
      if (this.selectedItemGroup === "area") return "Quantità scatole";
      if (this.selectedItemGroup === "linear") return "Quantità confezioni";
      return "Quantità pezzi";
    },
    mqFieldLabel() {
      if (this.selectedItemGroup === "linear") return "Quantità ML";
      return "Quantità Mq";
    },

    /* Ponte per v-model quantityInput */
    quantityInput: {
      get() {
        if (
          this.selectedItemGroup === "area" ||
          this.selectedItemGroup === "linear"
        ) {
          return this.newItem.boxQuantity;
        }
        return this.newItem.pieces;
      },
      set(v) {
        const n = +v || 0;
        if (this.selectedItemGroup === "area") {
          this.newItem.boxQuantity = n;
          const ppb = this.selectedItem.piecesPerBox || 1;
          this.newItem.pieces = n * ppb;
        } else if (this.selectedItemGroup === "linear") {
          this.newItem.boxQuantity = n;
          this.newItem.pieces = 0;
        } else {
          this.newItem.pieces = n;
        }
      },
    },

    /* Ponte per v-model mqPerQuantity */
    mqPerQuantity() {
      const s = this.selectedItem || {};
      const boxes = Number(this.newItem.boxQuantity) || 0;
      if (this.selectedItemGroup === "area") {
        const sqmPerBox = Number(s.sqmPerBox) || 0;
        const total = boxes * sqmPerBox;
        return total ? total.toFixed(2) : "";
      }
      if (this.selectedItemGroup === "linear") {
        const mlPerBox = Number(s.mlPerBox) || 0;
        const total = boxes * mlPerBox;
        return total ? total.toFixed(2) : "";
      }
      return "";
    },

    showMqField() {
      const s = this.selectedItem || {};
      if (!s || !s.category) return false;
      return (
        this.selectedItemGroup === "area" || this.selectedItemGroup === "linear"
      );
    },

    items() {
      return this.$store.getters["items/list"] ?? [];
    },

    filteredClients() {
      const query = (this.searchQueryClient || "").toLowerCase();
      // console.log("thisclients", this.clients);
      return this.clients
        .filter((c) => (c.clientName || "").toLowerCase().includes(query))
        .slice(0, 5);
    },

    // Tutti i nomi da mostrare nella colonna "Articolo"
    itemNames() {
      return (this.formData.items || []).map(
        (row) =>
          this.getItemName(row.itemId, this.categoryHintForRow(row)) || ""
      );
    },

    // Lunghezza massima in caratteri tra i nomi
    maxItemLen() {
      return this.itemNames.reduce((m, s) => Math.max(m, s.length), 0);
    },

    // Larghezza dinamica della colonna "Articolo" in ch, con limiti per non rompere il layout
    // - min 180px (leggibile anche con nomi brevi)
    // - valore centrale in ch (caratteri) = maxArtLen + 6 (un po' di respiro)
    // - max 52vw (mai oltre metà viewport nel modale)
    itemColWidth() {
      const ch = Math.max(10, Math.min(this.maxItemLen + 6, 72)); // clamp “logico”
      return `clamp(180px, ${ch}ch, 50vw)`;
    },

    isAddressValid() {
      // [sc-48762] l'indirizzo si scrive a mano: basta che sia compilato
      return indirizzoValido(this.formData.location?.address);
    },
    showSelectedItemOrderAlert() {
      return this.isOrderableOutOfStock(this.selectedItem);
    },
    selectedItemOrderLabel() {
      return this.itemSearchLabel(this.selectedItem);
    },
    canSaveCreate() {
      // [sc-49299] gli stessi obbligatori dell'API: cliente, indirizzo,
      // modalità di pagamento e almeno un articolo
      return (
        !!this.formData.clientId &&
        !!this.formData.payment_method &&
        this.formData.items.length > 0 &&
        this.isAddressValid &&
        !this.erroreSpese
      );
    },
    // [sc-49299] spesa spuntata senza importo valido: salvataggio spento
    erroreSpese() {
      return primoErroreSpese(this.spese);
    },
    ddtItems() {
      const AREA_CATS = [
        "piastrelle",
        "rivestimenti parete",
        "parquet",
        "laminati",
        "decking esterno",
      ];
      const LINEAR_CATS = ["profili", "sistemi di scarico"];
      return (this.formData.items || []).map((row) => {
        const fullItem =
          this.selectedByKey[`STOCK:${Number(row.itemId)}`] || {};
        const isArea = AREA_CATS.includes((row.category || "").toLowerCase());
        const isLinear = LINEAR_CATS.includes(
          (row.category || "").toLowerCase()
        );
        const qty = isArea || isLinear ? row.boxQuantity ?? 0 : row.pieces ?? 0;
        const uom =
          fullItem.salesUnit || (isArea ? "SC" : isLinear ? "CONF" : "PZ");
        return {
          description:
            fullItem.itemName || fullItem.itemCode || `Articolo #${row.itemId}`,
          quantity: qty,
          uom,
        };
      });
    },
  },
  data() {
    return {
      // [sc-49299] spese aggiuntive: null = voce non spuntata
      spese: speseDaPreventivo(),
      dateConfig: {
        locale: Italian,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        monthSelectorType: "static",
      },
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      // [sc-49299] dati del form in attesa che si confermi l'anteprima
      payloadInAttesa: null,
      // loading per i 3 combobox
      clientsLoading: false,
      // lista clienti filtrata per il combobox (evitiamo il vecchio computed)
      comboClients: [],

      showDuplicateModal: false,
      lastDuplicateQuoteInfo: { quoteId: null, address: null },
      showDupDocs: false,
      dupDocuments: [],
      showDdtModal: false,
      pendingDdt: null,

      dupLoading: false,
      dupError: "",
      dupQuote: null,

      addressInput: "", // testo in input
      addressDirty: false, // l'utente ha toccato/modificato l'input

      showDropdown: false,
      searchQueryClient: "",
      searchQueryItem: "",
      selectedByKey: {},
      pendingOrderItems: {},
      orderNote: "",
      panelVisible: true,
      selectedIndex: -1, // Indice dell'opzione attualmente evidenziata
      activeSearch: null, // "item" o "client" o null
      response: "",

      formData: {
        location: {
          name: "",
          address: "",
          link: "",
        },
        technical_queries: "",
        clientId: "",
        items: [],
        date: "",
        payment_method: "",
      },
      newItem: {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        listPrice: null,
        discountedPrice: null,
        price: "",
        iva: 0, // IVA a 0% di partenza
      },
      errorMessage: "",
      successMessage: "",
      selectedPlaceId: "",
      paymentOptions: [
        { value: "Contanti", label: "Contanti" },
        { value: "Carta di credito", label: "Carta di credito" },
        { value: "Bonifico", label: "Bonifico" },
        { value: "Assegno", label: "Assegno" }, // [sc-49299]
        { value: "Scegli successivamente", label: "Scegli successivamente" },
      ],
      ivaOptions: [
        { value: 0, label: "0%" },
        { value: 4, label: "4%" },
        { value: 10, label: "10%" },
        { value: 22, label: "22%" },
      ],
    };
  },

  methods: {
    goBack() {
      this.pendingNavigation = null;
      this.showBackModal = true;
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        // all'elenco, non alla pagina prima nella cronologia: dopo un
        // ricaricamento era di nuovo questa
        this.$router.push({ name: "quotes" });
      }
    },
    // Anche a campo vuoto (click sul campo): primi clienti per ultimo preventivo
    onSearchClient(q) {
      this.comboClients = clientiPerRicerca(this.clients, q);
    },
    // Anche a campo vuoto (click sul campo): primi articoli senza filtro
    onSearchItem(q) {
      this.itemsLoading = true;
      this.debouncedFetchItems(q || "");
    },
    async loadDuplicateQuote() {
      const id = this.lastDuplicateQuoteInfo?.quoteId;
      // console.debug("[dup] about to load", {
      //   lastDuplicateQuoteInfo: this.lastDuplicateQuoteInfo,
      //   id,
      // });
      if (!id) return;

      this.dupLoading = true;
      this.dupError = "";
      this.dupQuote = null;

      try {
        const { data } = await axiosInstance.get(`/quote/${id}`, {
          withCredentials: true,
        });
        // console.debug("[dup] GET /quote/:id response", data);

        // accetta sia {quote:{...}} sia {...} diretto
        const qRaw = data?.quote ?? data ?? {};
        // documents sia in quote che top-level
        this.dupDocuments = qRaw.documents ?? data?.documents ?? [];

        // parse location
        let parsedLocation = null;
        try {
          parsedLocation = asLoc(qRaw.location) || null;
        } catch {
          parsedLocation = null;
        }

        const items = (qRaw.quote_items || qRaw.items || []).map((qi) => {
          const cat = qi.item?.category || qi.category || "";
          return {
            category: cat,
            itemName: qi.item?.itemName || qi.item?.subBrand || qi.itemName,
            brand: qi.item?.subBrand || qi.brand,
            boxQuantity: cat === "piastrelle" ? qi.quantity : 0,
            pieces: cat === "piastrelle" ? 0 : qi.quantity,
            iva: qi.iva ?? 22,
            price: Number(qi.price ?? 0),
          };
        });

        this.dupQuote = {
          ...qRaw,
          location: parsedLocation,
          totalPrice: qRaw.totalPrice ?? data?.totalPrice ?? null,
          items,
        };

        // console.debug("[dup] normalized dupQuote", this.dupQuote);
      } catch (e) {
        // console.error("[dup] load error", e?.response || e);
        this.dupError =
          e?.response?.data?.message ||
          "Impossibile caricare il preventivo esistente.";
      } finally {
        this.dupLoading = false;
      }
    },

    openDuplicateModal(quoteId, address) {
      this.lastDuplicateQuoteInfo = {
        quoteId: quoteId ?? null,
        address: address ?? null,
      };
      this.dupError = "";
      this.dupQuote = null;
      this.showDuplicateModal = true;

      // 👇 evita di affidarti solo ai watcher
      if (this.lastDuplicateQuoteInfo.quoteId) {
        this.loadDuplicateQuote();
      }
    },

    closeDuplicateModal() {
      this.showDuplicateModal = false;
    },

    // util formattazioni (riusate nel template)
    number(v) {
      return (typeof v === "number" ? v : Number(v || 0)).toFixed(2);
    },
    money(v) {
      return `€ ${this.number(v)}`;
    },
    formatDocName(name) {
      return (
        (name ?? "")
          .toString()
          // prima togli eventuale ".dev" immediatamente prima di ".pdf"
          .replace(/\.dev(?=\.pdf$)/i, "")
          // poi rimuovi "_N_<numero>.pdf" in fondo
          .replace(/_N_\d+\.pdf$/i, "")
      );
    },
    formatToLocalDate,

    // azioni footer
    onChangeAddress() {
      this.showDuplicateModal = false;
      this.$nextTick(() =>
        document.getElementById("indirizzo-consegna")?.focus()
      );
    },
    async onDuplicateWithEdit() {
      const sourceId = this.lastDuplicateQuoteInfo?.quoteId;
      this.showDuplicateModal = false;

      if (!sourceId) return;

      try {
        // se il dettaglio non è già caricato, lo carico ora
        if (!this.dupQuote || this.dupQuote.id !== sourceId) {
          this.dupLoading = true;
          const { data } = await axiosInstance.get(`/quote/${sourceId}`, {
            withCredentials: true,
          });
          const loc = asLoc(data?.quote?.location);
          this.dupQuote = { ...data.quote, location: loc };
        }

        const q = this.dupQuote;

        // mappo le righe dal server -> formData.items
        const mappedItems = (q.quote_items || [])
          .map((qi) => {
            if (qi.item) {
              const cat = qi.item.category;
              return {
                ...prezziRigaDuplicata(qi),
                itemId: qi.item.id,
                boxQuantity: cat === "piastrelle" ? qi.quantity : 0,
                pieces: cat === "piastrelle" ? 0 : qi.quantity,
                iva: qi.iva ?? 22,
              };
            }
            return null;
          })
          .filter(Boolean);

        // cache per etichette/nomi in tabella
        (q.quote_items || []).forEach((qi) => {
          if (qi.item) this.selectedByKey[KEY.STOCK(qi.item.id)] = qi.item;
        });

        // compilo la form con i dati del preventivo esistente
        this.formData = {
          ...this.formData,
          clientId: q.clientId,
          payment_method: q.payment_method || "",
          technical_queries: q.technical_queries || "",
          items: mappedItems,
          location: {
            name: "",
            address: "",
            link: "",
          }, // ← SVUOTO
        };
        // [sc-49299] anche le spese del preventivo di partenza
        this.spese = speseDaPreventivo(q);
        this.addressInput = "";

        this.newItem = this.resetNewItem();

        this.$nextTick(() =>
          document.getElementById("indirizzo-consegna")?.focus()
        );
        this.$toast.info(
          `Contenuto del preventivo #${q.id} copiato. Inserisci un indirizzo diverso e salva.`
        );
      } catch (e) {
        this.$toast.error("Impossibile duplicare questo preventivo ora.");
      } finally {
        this.dupLoading = false;
      }
    },
    onViewedExisting() {
      // opzionale: analytics/log
    },

    categoryHintForRow(row) {
      if (row?.category) return row.category;
      return "STOCK";
    },
    rowCategoryGroup(row) {
      const it = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      return getCategoryGroup(it?.category);
    },
    isStockTiles(row) {
      return this.rowCategoryGroup(row) === "area";
    },
    qtyCell(row) {
      const group = this.rowCategoryGroup(row);
      if (group === "area" || group === "linear")
        return Number(row.boxQuantity || 0);
      return Number(row.pieces || row.quantity || 0);
    },
    mqCell(row) {
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      const group = this.rowCategoryGroup(row);
      if (group === "area") {
        const sqmPerBox = Number(it.sqmPerBox) || 0;
        const boxes = Number(row.boxQuantity) || 0;
        const total = boxes * sqmPerBox;
        return total ? `${eur(total)} mq` : "—";
      }
      if (group === "linear") {
        const mlPerBox = Number(it.mlPerBox) || 0;
        const boxes = Number(row.boxQuantity) || 0;
        const total = boxes * mlPerBox;
        return total ? `${eur(total)} ml` : "—";
      }
      return "—";
    },

    getItemFromStore(id) {
      if (!id) return {};

      const key = KEY.STOCK(id);

      if (this.selectedByKey[key]) return this.selectedByKey[key];

      const stk =
        (this.items || []).find((i) => i.id === id) ||
        (this.filteredItems || []).find((i) => i.id === id);
      if (stk) {
        this.selectedByKey[key] = stk;
        return stk;
      }
      return {};
    },

    // Mappa azioni store
    ...mapActions(["uploadQuoteDocument", "createOrder"]),

    dettaglioVoceArticolo,
    itemSearchLabel(it) {
      if (!it) return "";
      return it.itemName
        ? `${it.itemName} ${it.measureDesc || ""}`.trim()
        : `${it.subBrand || ""} ${it.fixtureType || ""} ${
            it.fixturePosition || ""
          }`.trim();
    },

    warehouseCount(item) {
      const stock = Number(item?.warehouse?.inWarehouse ?? item?.inWarehouse);
      return Number.isFinite(stock) ? stock : 0;
    },

    isOrderableOutOfStock(item) {
      return !!item?.id && this.warehouseCount(item) <= 0;
    },

    isQtyExceedingStock(row) {
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      if (!item?.id) return false;
      const stock = this.warehouseCount(item);
      if (stock <= 0) return false;
      return this.qtyCell(row) > stock;
    },

    updateRowQty(row, val) {
      const n = Math.max(0, Math.round(val) || 0);
      const group = this.rowCategoryGroup(row);
      if (group === "area" || group === "linear") {
        row.boxQuantity = n;
        const storeItem = this.getItemFromStore(
          row.itemId,
          this.categoryHintForRow(row)
        );
        row.pieces = n * (storeItem?.piecesPerBox || 1);
      } else {
        row.pieces = n;
      }
    },

    hasIncompleteTileStockData(item) {
      const group = getCategoryGroup(item?.category);
      if (group === "area") return !(Number(item?.sqmPerBox) > 0);
      if (group === "linear") return !(Number(item?.mlPerBox) > 0);
      return false;
    },

    validateQuoteStockItem(rowOrItem) {
      const itemId = rowOrItem?.itemId ?? rowOrItem?.id;
      const item = rowOrItem?.id
        ? rowOrItem
        : this.getItemFromStore(itemId, this.categoryHintForRow(rowOrItem));

      if (!item?.id) return true;
      if (!this.hasIncompleteTileStockData(item)) return true;

      const group = getCategoryGroup(item?.category);
      const field = group === "linear" ? "ml per confezione" : "mq per scatola";
      this.$toast.error(
        `Questo articolo non può essere aggiunto al preventivo: completa prima il campo "${field}" nell'anagrafica articolo.`
      );
      return false;
    },

    validateQuoteItemsBeforeSubmit() {
      return (this.formData.items || []).every((row) =>
        this.validateQuoteStockItem(row)
      );
    },

    isOrderQueued(item) {
      return !!item?.id && !!this.pendingOrderItems[item.id];
    },

    isOrderQueuedRow(row) {
      return !!row?.itemId && !!this.pendingOrderItems[row.itemId];
    },

    orderQuantityForItem(item) {
      if (!item?.id) return 1;

      const stock = this.warehouseCount(item);

      const row = (this.formData.items || []).find(
        (entry) => Number(entry?.itemId) === Number(item.id)
      );
      if (row) {
        const rowGroup = getCategoryGroup(item.category);
        const qty =
          rowGroup === "area" || rowGroup === "linear"
            ? Number(row.boxQuantity || row.quantity || 0)
            : Number(row.pieces || row.quantity || 0);
        if (qty > 0) {
          return stock > 0 ? Math.max(qty - stock, 1) : qty;
        }
      }

      if (this.newItem.itemId === item.id) {
        const g = getCategoryGroup(item.category);
        const qty =
          g === "area" || g === "linear"
            ? Number(this.newItem.boxQuantity || 0)
            : Number(this.newItem.pieces || 0);
        if (qty > 0) return stock > 0 ? Math.max(qty - stock, 1) : qty;
      }
      return 1;
    },

    buildPendingOrderNote(quoteId) {
      return `Ordine per preventivo #${quoteId}`;
    },

    async processPendingOrders(quoteId) {
      const itemIds = Object.keys(this.pendingOrderItems || {}).map(Number);
      if (!quoteId || !itemIds.length) return;

      const results = await Promise.allSettled(
        itemIds.map((itemId) =>
          this.createOrder({
            itemId,
            quantity: this.orderQuantityForItem(this.getItemFromStore(itemId)),
            notes: this.buildPendingOrderNote(quoteId, itemId),
          })
        )
      );

      const failed = results.filter((r) => r.status === "rejected");
      if (failed.length) {
        this.$toast.error(
          `${failed.length} ordine/i non creati dopo il salvataggio del preventivo.`
        );
      } else {
        this.$toast.success(
          "Ordini collegati al preventivo creati con successo."
        );
      }
    },

    async processPendingDdt(quoteId) {
      if (!this.pendingDdt || !quoteId) return;
      try {
        const { data: ddt } = await axiosInstance.post("/ddt", {
          causale: this.pendingDdt.causale,
          quoteId,
          clientId: this.formData.clientId || null,
          magazziniereId: this.pendingDdt.magazziniereId,
          operatoreId: this.pendingDdt.operatoreId,
          items: this.pendingDdt.items ?? this.ddtItems,
        });

        const blob = generateDdtPdf(ddt);
        const isDev =
          process.env.NODE_ENV === "development" ||
          import.meta?.env?.MODE === "development" ||
          process.env?.VUE_APP_NODE_ENV === "development";
        const withSuffixBeforeExt = (name, suffix) => {
          if (!suffix) return name;
          const dot = name.lastIndexOf(".");
          return dot <= 0
            ? `${name}.${suffix}`
            : `${name.slice(0, dot)}.${suffix}${name.slice(dot)}`;
        };
        const baseName = ddt.quoteId
          ? ddt.causale === "consegna"
            ? `DDT_${ddt.quoteId}_CONSEGNA_${ddt.sequence}.pdf`
            : `DDT_${ddt.quoteId}_${ddt.causale.toUpperCase()}.pdf`
          : `DDT_N_${ddt.id}.pdf`;
        const filename = withSuffixBeforeExt(baseName, isDev ? "dev" : "");

        const formData = new FormData();
        formData.append(
          "document",
          new File([blob], filename, { type: "application/pdf" })
        );
        await axiosInstance.post(`/upload/ddts/${ddt.id}/documents`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);

        this.$toast.success(`DDT N° ${ddt.id} generato e salvato.`);
      } catch (e) {
        this.$toast.error(
          e?.response?.data?.message || "Errore nella generazione del DDT."
        );
      } finally {
        this.pendingDdt = null;
      }
    },

    queueOrderFromQuoteItem(item) {
      if (!item?.id || this.isOrderQueued(item)) return;

      this.pendingOrderItems = {
        ...this.pendingOrderItems,
        [item.id]: true,
      };

      this.$toast.info(
        "Ordine messo in coda. Verrà creato al salvataggio del preventivo."
      );
    },

    unqueueOrderFromQuoteItem(item) {
      if (!item?.id || !this.isOrderQueued(item)) return;

      const next = { ...this.pendingOrderItems };
      delete next[item.id];
      this.pendingOrderItems = next;

      if (this.newItem.itemId === item.id) this.orderNote = "";

      this.$toast.info("Ordine rimosso dalla coda.");
    },

    toggleItemsList() {
      this.panelVisible = !this.panelVisible;
    },

    startSearch(type) {
      this.activeSearch = type; // 'client' o 'item'
      this.showDropdown = true;
      this.selectedIndex = -1;
      // azzera solo il campo “attivo”
      if (type === "client") this.searchQueryClient = "";
      if (type === "item") this.searchQueryItem = "";
    },

    handleKey(event) {
      if (!this.showDropdown) return;

      // Quale array devo navigare?
      let list;
      if (this.activeSearch === "client") {
        list = this.filteredClients;
      } else if (this.activeSearch === "item") {
        list = this.filteredItems;
      } else {
        list = [];
      }

      // ========== freccia giù ==========
      if (event.key === "ArrowDown") {
        this.selectedIndex =
          this.selectedIndex < list.length - 1 ? this.selectedIndex + 1 : 0;
        event.preventDefault();

        // ========== freccia su ==========
      } else if (event.key === "ArrowUp") {
        this.selectedIndex =
          this.selectedIndex > 0 ? this.selectedIndex - 1 : list.length - 1;
        event.preventDefault();

        // ========== ENTER ==========
      } else if (event.key === "Enter") {
        if (this.selectedIndex >= 0 && this.selectedIndex < list.length) {
          const chosen = list[this.selectedIndex];

          if (this.activeSearch === "client") {
            // selezione cliente
            this.formData.clientId = chosen.id;
            this.searchQueryClient = chosen.clientName;
          } else if (this.activeSearch === "item") {
            // selezione articolo
            this.newItem.itemId = chosen.id;
            this.searchQueryItem = chosen.itemName
              ? `${chosen.itemName} ${chosen.measureDesc}`
              : `${chosen.subBrand} ${chosen.fixtureType || ""} ${
                  chosen.fixturePosition || ""
                }`;
            this.prezziDaArticolo(chosen);
            // memorizza l'oggetto articolo completo
            // this.selectedItemById[chosen.id] = chosen;
            this.selectedByKey[KEY.STOCK(chosen.id)] = chosen;
          }
          this.showDropdown = false;
          this.selectedIndex = -1;
        }
        event.preventDefault();
      }
    },

    selectClient(client) {
      this.formData.clientId = client.id;
      this.searchQueryClient = client.clientName;
      this.hideDropdown();
    },
    selectItem(item) {
      this.newItem.itemId = item.id;
      this.orderNote = "";
      this.searchQueryItem = this.itemSearchLabel(item);
      // const item =
      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // listino e scontato dell'articolo, prezzo ivato calcolato
      this.prezziDaArticolo(item);
      this.hideDropdown();
    },

    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
        this.selectedIndex = -1;
        this.activeSearch = null;
      }, 300);
    },

    nameForDisplay(src) {
      return this.itemDisplayFromObj(src || {}).title || "Sconosciuto";
    },

    /**
     * Gestisce la selezione di un cliente dal dropdown.
     * Chiude il dropdown e aggiorna la searchQueryClient con il nome del cliente selezionato.
     */
    handleClientSelection() {
      this.showDropdown = false;
      this.searchQueryClient = this.getClientName(this.formData.clientId);
    },

    /* Listino e scontato dell'articolo sono imponibili: il prezzo ivato
     della riga è lo scontato (o il listino se manca) più l'IVA scelta */
    prezziDaArticolo(item) {
      this.newItem.listPrice = numeroPrezzo(item?.price);
      this.newItem.discountedPrice = numeroPrezzo(item?.priceDiscounted);
      this.ricalcolaPrezzoIvato();
    },

    ricalcolaPrezzoIvato() {
      if (!this.newItem.itemId) return;
      this.newItem.price = prezzoIvato(
        prezzoBase(this.newItem),
        this.newItem.iva
      );
    },

    async onSelectItem() {
      // 1) hide dropdown
      this.hideDropdown();
      // console.log("newitem", this.newItem);
      // 2) trova l'item selezionato
      const item = this.getItemFromStore(this.newItem.itemId, "STOCK");
      if (!item.id) return;

      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // 3) aggiorna la searchQuery per mostrare il nome selezionato
      this.searchQueryItem = item.itemName
        ? `${item.itemName} ${item.measureDesc}`
        : `${item.subBrand} ${item.fixtureType || ""} ${
            item.fixturePosition || ""
          }`;

      // 4) popola i prezzi
      this.prezziDaArticolo(item);
    },

    addItem() {
      this.errorMessage = "";
      this.successMessage = "";

      const isAreaOrLinear =
        this.selectedItemGroup === "area" ||
        this.selectedItemGroup === "linear";
      const selected = this.selectedItem;

      const qty = isAreaOrLinear
        ? Number(this.newItem.boxQuantity || 0)
        : Number(this.newItem.pieces || 0);

      if (!this.newItem.itemId || qty <= 0 || !this.newItem.price) {
        this.errorMessage =
          "Compila tutti i campi prima di aggiungere un articolo.";
        this.$toast.error(this.errorMessage);
        return;
      }

      if (this.erroreScontatoRiga) {
        this.errorMessage = this.erroreScontatoRiga;
        this.$toast.error(this.errorMessage);
        return;
      }

      if (!this.validateQuoteStockItem(this.selectedItem)) return;

      const fullObj = this.selectedItem;
      if (fullObj?.id) {
        this.selectedByKey[KEY.STOCK(fullObj.id)] = fullObj;
      }

      const existing = this.formData.items.find(
        (r) => r.itemId === this.newItem.itemId && r.iva === this.newItem.iva
      );

      if (existing) {
        if (isAreaOrLinear) {
          existing.boxQuantity = this.newItem.boxQuantity;
          existing.pieces = 0;
        } else {
          existing.pieces = this.newItem.pieces;
        }
        existing.price = this.newItem.price;
        existing.listPrice = this.newItem.listPrice;
        existing.discountedPrice = numeroPrezzo(this.newItem.discountedPrice);
        existing.iva = this.newItem.iva;

        this.$nextTick(() => {
          this.successMessage = "Quantità aggiornata per l'articolo esistente.";
          this.$toast.success(this.successMessage);
        });
        return; // niente push()
      }

      this.formData.items.push({
        itemId: this.newItem.itemId ?? null,
        boxQuantity: this.newItem.boxQuantity,
        pieces: this.newItem.pieces,
        price: this.newItem.price,
        listPrice: this.newItem.listPrice,
        discountedPrice: numeroPrezzo(this.newItem.discountedPrice),
        iva: this.newItem.iva,
        category: selected.category || "STOCK",
      });
      // console.log("formData.items: ", this.formData.items);
      this.$nextTick(() => {
        this.successMessage = "Articolo aggiunto con successo.";
        this.$toast.success(this.successMessage);
      });
      this.newItem = {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        listPrice: null,
        discountedPrice: null,
        price: "",
        iva: 0,
        category: "",
      };
      this.searchQueryItem = "";
      this.showDropdown = false;
    },

    removeItem(index) {
      this.formData.items.splice(index, 1);
    },

    saveToLocalStorage(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },

    loadFromLocalStorage(key) {
      const savedData = localStorage.getItem(key);
      if (savedData) {
        return JSON.parse(savedData);
      }
      return null;
    },

    cap(w) {
      const s = (w || "").toString().trim();
      return s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : "";
    },

    itemDisplay(row) {
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      return this.itemDisplayFromObj(it);
    },

    // Usa la stessa logica di itemDisplay ma partendo da id+categoria
    itemDisplayById(id, categoryHint) {
      const it = this.getItemFromStore(id, categoryHint) || {};
      // riusa la parte di formattazione dentro itemDisplay:
      // copiamo la stessa logica in una funzione dedicata
      return this.itemDisplayFromObj(it);
    },

    // Estrae { title, meta } da un oggetto item già risolto
    itemDisplayFromObj(it = {}) {
      const Cap = (s) =>
        (s || "")
          .toString()
          .trim()
          .replace(/^\w/, (c) => c.toUpperCase());

      // ---- GRUPPO AREA (piastrelle, rivestimenti, parquet, laminati, decking) ----
      if (getCategoryGroup(it.category) === "area") {
        const title = it.itemName || "Articolo";
        const meta =
          it.measureDesc ||
          it.formatLabel ||
          (it.widthCm && it.heightCm ? `${it.widthCm}×${it.heightCm} cm` : "");
        return { title: title || "Articolo", meta };
      }

      // ---- ALTRI GRUPPI ----
      const title =
        it.itemName ||
        [it.brand, it.subBrand].filter(Boolean).join(" \u2192 ").trim() ||
        "Articolo";

      const T = Cap(it.fixtureType || "");
      const P =
        it.fixturePosition === "terra"
          ? "a terra"
          : Cap(it.fixturePosition || "");

      // se ho info di tipo/posizione le mostro; altrimenti fallback alla subCategory (es. "Sanitari"/"Altro")
      const metaParts = [T, P].filter(Boolean);
      const meta = metaParts.length
        ? metaParts.join(" ")
        : Cap(it.subCategory || "");

      return { title, meta };
    },

    // ⚠️ Back-compat: ora usa la nuova formattazione e restituisce solo il titolo
    getItemName(id, categoryHint) {
      return this.itemDisplayById(id, categoryHint).title;
    },

    getClientName(clientId) {
      const client = this.clients.find((c) => c.id === clientId);
      return client ? client.clientName : "Sconosciuto";
    },

    eur,
    importoAnteprima(v) {
      return v == null ? "—" : `€ ${eur(v)}`;
    },
    formatIva(iva) {
      const percentageSymbol = "%";
      return `${iva} ${percentageSymbol}`;
    },

    // Formato italiano, come l'anteprima della riga: € 1.234,50
    formatPrice(price) {
      return `€ ${eur(price)}`;
    },

    unitForRow(row) {
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      if (
        String(row?.itemName || it?.itemName || "")
          .toLowerCase()
          .includes("battiscopa")
      )
        return "€/mL";
      const group = getCategoryGroup(it.category);
      if (group === "area") return "€/mq";
      if (group === "linear") return "€/ml";
      return "€/pz";
    },

    mqForRow(row) {
      // console.log("row", row);
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      // console.log("mqForRow item: ", item);
      const sqmPerBox = Number(item.sqmPerBox) || 0;
      const boxes = Number(row.boxQuantity) || 0;
      const total = sqmPerBox * boxes;
      return total ? total.toFixed(2) : "";
    },

    resetNewItem() {
      return {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        category: "",
        quantity: 0,
        iva: 0,
      };
    },

    // Righe della tabella articoli del PDF (colonne e formati in pdfArticoli)
    buildQuoteTable(quote) {
      // Sorgente righe (creazione: quote.items; fallback: quote.quote_items o formData.items)
      const rows =
        (Array.isArray(quote?.items) && quote.items.length
          ? quote.items
          : []) ||
        (Array.isArray(quote?.quote_items) && quote.quote_items.length
          ? quote.quote_items
          : []) ||
        (Array.isArray(this?.formData?.items) ? this.formData.items : []);

      const lower = (v) => String(v || "").toLowerCase();
      const getFromStore = (id, cat) => this.getItemFromStore?.(id, cat) || {};

      const resolveObj = (it) => {
        if (it.item) return it.item;
        const cat = it.category || "STOCK";
        const store = getFromStore(it.itemId, cat);
        return { ...it, ...store };
      };

      const nameForPdf = (src) => {
        const isTiles =
          lower(src.category) === "piastrelle" ||
          lower(src.subCategory) === "piastrelle";
        if (isTiles) {
          return (
            [src.itemName, src.measureDesc].filter(Boolean).join(" ") || "-"
          );
        }
        return (
          src.itemName ||
          [src.brand, src.subBrand].filter(Boolean).join(" ") ||
          "-"
        );
      };

      const righe = rows.map((it) => {
        const src = resolveObj(it);
        const name = nameForPdf(src);
        const isTiles =
          lower(it.item?.category || it.category || src.category) ===
          "piastrelle";

        let qty = 0;
        if (isTiles) {
          const sqmPerBox = Number(src.sqmPerBox || it.sqmPerBox || 0) || 0;
          const boxes = Number(it.boxQuantity || it.quantity || 0) || 0;
          qty = sqmPerBox
            ? Number((boxes * sqmPerBox).toFixed(2))
            : Number(boxes.toFixed(2));
        } else {
          qty = Number(it.pieces || it.quantity || it.boxQuantity || 0) || 0;
        }

        return {
          group: String(
            it.item?.category ?? it.category ?? src.category ?? "generale"
          )
            .trim()
            .toUpperCase(),
          code:
            it.item?.itemCode ??
            src.itemCode ??
            it.item?.code ??
            it.code ??
            src.code ??
            "-",
          desc: name,
          unit: name.toLowerCase().includes("battiscopa")
            ? "mL"
            : isTiles
            ? "mQ"
            : "pz",
          qty,
          // prezzi imponibili fotografati dall'API sulla riga
          listPrice: it.listPrice ?? null,
          discountedPrice: it.discountedPrice ?? null,
          unitPrice: Number(it.price || 0) || 0,
          // IVA 0 è un'aliquota valida: `|| 22` la stampava al 22% [sc-49299]
          iva:
            it.iva === null || it.iva === undefined || it.iva === ""
              ? 22
              : Number(it.iva),
        };
      });

      return righe;
    },

    vaiAiPreventivi(ritardo = 0) {
      setTimeout(() => {
        // preventivo già salvato: niente conferma di uscita
        this.navigationConfirmed = true;
        this.$router.push({ name: "quotes" });
        this.errorMessage = "";
        this.successMessage = "";
      }, ritardo);
    },

    // [sc-49299] preventivo salvato dalla finestra di stampa (PDF caricato o
    // no): si torna all'elenco
    dopoStampa() {
      this.vaiAiPreventivi();
    },

    // Dati da mandare all'API dopo i controlli del form; null se manca qualcosa
    preparaPreventivo() {
      // 0) Validazioni minime
      if (!this.isAddressValid) {
        this.addressDirty = true;
        this.$toast.error("Scrivi l'indirizzo di consegna.");
        return null;
      }

      if (this.formData.items.length === 0) {
        this.errorMessage = "Aggiungi almeno un articolo prima di salvare";
        this.$toast.error(this.errorMessage);
        return null;
      }

      // [sc-49299] spesa spuntata senza importo valido
      const erroreSpese = primoErroreSpese(this.spese);
      if (erroreSpese) {
        this.$toast.error(erroreSpese);
        return null;
      }

      // 1) Se hai un articolo parzialmente compilato nei campi input, aggiungilo prima del salvataggio
      if (
        this.newItem.itemId &&
        (this.newItem.boxQuantity || this.newItem.pieces)
      ) {
        if (!this.validateQuoteStockItem(this.selectedItem)) return null;
        this.formData.items.push({ ...this.newItem });
      }

      if (!this.validateQuoteItemsBeforeSubmit()) return null;

      // 2) Ogni riga manda `discountedPrice` (anche null): l'API fotografa
      // listino e scontato e calcola lei il prezzo ivato. Righe senza la
      // chiave (bozze salvate prima) prendono lo scontato dell'articolo.
      const payload = {
        ...this.formData,
        items: this.formData.items.map((r) => ({
          ...r,
          discountedPrice: numeroPrezzo(
            "discountedPrice" in r
              ? r.discountedPrice
              : this.getItemFromStore(r.itemId, "STOCK")?.priceDiscounted
          ),
        })),
        technical_queries: (this.formData.technical_queries || "").trim(),
        ...speseDaMandare(this.spese),
      };

      if (payload.date && payload.date.length === 10) {
        payload.date = new Date(payload.date + "T00:00:00").toISOString();
      }

      const sanitize = (s) => (s || "").replace(/\p{C}+/gu, "");
      payload.technical_queries = sanitize(payload.technical_queries);
      return payload;
    },

    // [sc-49299] «Anteprima preventivo» non salva: apre l'anteprima con i dati
    // del form. Si salva solo con «Salva e scarica PDF» (salvaDaStampa).
    onCreateQuoteAndGeneratePdf() {
      this.errorMessage = "";
      this.successMessage = "";
      const payload = this.preparaPreventivo();
      if (!payload) return;
      this.payloadInAttesa = payload;
      this.apriStampa(this.datiAnteprima(payload));
    },

    // Dati del PDF dal form, nella forma del preventivo che l'API restituisce
    // dopo il salvataggio: stesse righe, stessi prezzi ivati, stesso totale
    datiAnteprima(payload) {
      const items = payload.items.map((r) => {
        const art = this.getItemFromStore(r.itemId, "STOCK") || {};
        // come l'API: listino dell'articolo
        const listPrice = numeroPrezzo(art.price) ?? r.listPrice ?? null;
        const iva = r.iva ?? 22;
        return {
          ...r,
          category: art.category || r.category,
          sqmPerBox: art.sqmPerBox,
          mlPerBox: art.mlPerBox,
          iva,
          listPrice,
          price: prezzoIvatoRiga({
            listPrice,
            discountedPrice: r.discountedPrice,
            iva,
          }),
        };
      });
      const quote = {
        ...payload,
        id: null,
        date: payload.date || new Date().toISOString(),
        items,
      };
      return datiPdf(quote, {
        cliente: clientePerPdf(this.clienteSelezionato || {}),
        righe: this.buildQuoteTable(quote),
        totaleArticoli: totaleArticoli(
          items.map((it) => ({
            ...it,
            quantity: ["area", "linear"].includes(getCategoryGroup(it.category))
              ? it.boxQuantity
              : it.pieces,
          }))
        ),
      });
    },

    // [sc-49299] anteprima confermata: salva, poi i dati del PDF dal
    // preventivo salvato. null se il salvataggio non è andato.
    async salvaDaStampa() {
      const wrap = await this.salvaPreventivo(this.payloadInAttesa);
      if (!wrap) return null;
      const quote = wrap.newQuote;
      const dati = quote
        ? datiPdf(quote, {
            cliente: clientePerPdf(quote),
            righe: this.buildQuoteTable(quote),
            totaleArticoli: parseFloat(wrap.totalPrice || 0),
          })
        : null;
      this.resetForm();
      if (!dati) {
        this.$toast.error(
          "Dati preventivo non disponibili per la generazione del PDF."
        );
        this.vaiAiPreventivi(4000);
      }
      return dati;
    },

    resetForm() {
      this.payloadInAttesa = null;
      this.formData = {
        location: {
          name: "",
          address: "",
          link: "",
        },
        technical_queries: "",
        clientId: "",
        items: [],
        date: "",
        payment_method: "",
      };

      this.newItem = this.resetNewItem();
      this.searchQueryItem = "";
      this.spese = speseDaPreventivo();

      this.resetLocation();
    },

    // Salvataggio del preventivo: la risposta dell'API (`quote`), oppure null
    // dopo aver dato il messaggio d'errore
    async salvaPreventivo(payload) {
      try {
        const response = await this.$store.dispatch("createQuote", payload);
        this.response = response; // mantengo per compatibilità col tuo codice

        if (response?.status !== 200 && response?.status !== 201) {
          // ⬇️ ramo 409
          if (
            response?.status === 409 &&
            response?.data.code === "QUOTE_DUPLICATE"
          ) {
            this.segnalaDuplicato(response?.data);
            return null;
          }

          // ...altri errori
          this.errorMessage =
            response.data?.details ||
            response.data?.message ||
            "Impossibile creare il preventivo.";
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
          return null;
        }

        this.successMessage =
          response.data?.message || "Preventivo creato con successo!";
        this.$toast.success(this.successMessage);

        const quoteWrap = response.data?.quote || {};
        const createdQuoteId = Number(quoteWrap?.newQuote?.id || 0);
        await this.processPendingOrders(createdQuoteId);
        await this.processPendingDdt(createdQuoteId);
        return quoteWrap;
      } catch (error) {
        const resp = error?.response;

        // ⬇️ ramo 409
        if (resp?.status === 409 && resp?.data?.code === "QUOTE_DUPLICATE") {
          this.segnalaDuplicato(resp?.data);
          return null;
        }

        // ...altri errori
        this.errorMessage =
          resp?.data?.message ||
          resp?.data?.details ||
          resp?.data?.error ||
          "Errore durante la creazione del preventivo.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
        return null;
      }
    },

    segnalaDuplicato(d = {}) {
      const details = (typeof d.details === "object" && d.details) || {};
      const id =
        details.quoteId ??
        details.id ??
        details.quote?.id ??
        d.quoteId ??
        d.id ??
        null;

      const address =
        details.address ?? this.formData?.location?.address ?? null;

      this.$toast.error(
        d.message ||
          d.details ||
          "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso..."
      );
      this.openDuplicateModal(id, address);
    },

    onAddressTyping() {
      this.addressDirty = true;
      this.formData.location = {
        name: "",
        address: this.addressInput,
        link: linkMaps(this.addressInput),
      };
    },

    resetLocation() {
      this.formData.location = { name: "", address: "", link: "" };
      this.addressInput = "";
      this.addressDirty = false;
    },

    // --- pulizia selezione articolo di magazzino ---
    clearItemSelection() {
      const iva = this.newItem.iva ?? 0; // preserva l'IVA scelta
      Object.assign(this.newItem, this.resetNewItem(), { iva });
      this.searchQueryItem = "";
      this.orderNote = "";
    },
  },

  watch: {
    // 🔄 Ricerca + pulizia selezione se l'utente svuota il campo
    searchQueryItem(newQ, oldQ) {
      // se l'utente ha cancellato il testo ed era selezionato un articolo → pulisci
      if (oldQ && !newQ.trim() && this.newItem.itemId)
        this.clearItemSelection();

      // niente testo: tornano i primi articoli, come al click sul campo
      this.debouncedFetchItems(newQ.trim());
    },

    // IVA o scontato cambiati: il prezzo ivato riparte sempre dalla base
    "newItem.iva"() {
      this.ricalcolaPrezzoIvato();
    },
    "newItem.discountedPrice"() {
      this.ricalcolaPrezzoIvato();
    },

    // aggiornamento riga esistente (come avevi)
    newItem: {
      deep: true,
      handler(nv) {
        if (!nv) return;

        // Trova la riga esistente in base all'id correntemente selezionato
        const id = nv.itemId;
        // console.log({ nv: nv, id: id });
        if (!id) return;

        const key = "itemId";
        // console.log("key", key);
        // console.log("formdata", this.formData.items);
        const row = this.formData.items.find((x) => x[key] === id);
        // console.log("row", row);

        // Se non è stata ancora aggiunta con addItem(), non toccare nulla
        if (!row) return;

        const group = getCategoryGroup(this.selectedItem?.category);
        const isBoxBased = group === "area" || group === "linear";
        row.boxQuantity = isBoxBased ? nv.boxQuantity || 0 : 0;
        row.pieces = isBoxBased ? 0 : nv.pieces || 0;
        row.price = nv.price;
        row.listPrice = nv.listPrice;
        row.discountedPrice = numeroPrezzo(nv.discountedPrice);
        row.iva = nv.iva;
        // console.log("row after update", row);
      },
    },
    //       this.selectedItem.category === "piastrelle"
    //         ? nv.boxQuantity
    //         : this.selectedItem.subCategory === "piastrelle"
    //         ? nv.sqmQuantity
    //         : nv.pieces || 0;
    //     row.quantity = qty;
    //     row.boxQuantity = nv.boxQuantity;
    //     row.pieces = nv.pieces;
    //     row.price = nv.price;
    //     row.iva = nv.iva;
    //   },
    //   deep: true,
    // },

    showDuplicateModal(v) {
      if (
        v &&
        this.lastDuplicateQuoteInfo &&
        this.lastDuplicateQuoteInfo.quoteId
      ) {
        this.loadDuplicateQuote();
      }
    },
    lastDuplicateQuoteInfo: {
      deep: true,
      handler(nv) {
        if (this.showDuplicateModal && nv && nv.quoteId) {
          this.loadDuplicateQuote();
        }
      },
    },
  },

  mounted() {
    this.panelVisible = window.innerWidth >= 768;
    this.$nextTick(() => {
      this.addressInput = this.formData?.location?.address || "";
    });
  },
};
</script>

<style src="@/css/CreateQuotePage.css"></style>
